import { find as _find, isEmpty as _isEmpty } from 'lodash';

const groupValidator = {
  /**
   * Verifies if the given object fullfilled the criteria
   * of order with car sales and registration.
   * @returns {Boolean}
   */
  carSalesWithRegistration: data => {
    return data.type === 'car_sales' && _find(data.services, { name: 'carRegistration' });
  },
  carItem: data => {
    return data.type === 'car';
  },
  withAddress: data => {
    return data.groupSequences && data.groupSequences.indexOf('withAddress') > -1;
  },
  withMessage: data => {
    return data.groupSequences && data.groupSequences.indexOf('withMessage') > -1;
  },
  withEmailContact: data => {
    return data.groupSequences && data.groupSequences.indexOf('withEmailContact') > -1;
  },
  withPhoneContact: data => {
    return data.groupSequences && data.groupSequences.indexOf('withPhoneContact') > -1;
  },
  withClientMobilePhone: (data, processedData) => {
    return _isEmpty(processedData.roles) || (processedData.roles && processedData.roles.indexOf('ROLE_CUSTOMER') > -1);
  },
  withoutDocTemplate: data => {
    return !data.docTemplate;
  },
};

export default groupValidator;
